import React from "react";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";
import CancelIcon from "../../assets/svg/Cancel.svg";

const OrgUpgradeNotEligible = (props) => {
  const { upgradePackageInfo, countdown } = props;
  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <main className="main-content-cancel">
        <div className="icon-container">
          <img src={SMSMagicSvg} alt="SMS-Magic Icon" className="icon-sms" />
          <div className="dotted-line-red" />

          <div>
            <div>
              <img src={CancelIcon} alt="cancel Icon" className="cancel-icon" />
            </div>
          </div>

          <div className="dotted-line-red" />

          <div className="salesforce-logo-container">
            <img
              src={SalesforceImg}
              alt="Salesforce Logo"
              className="salesforce-logo"
              style={{ width: "180px", height: "126.75px" }}
            />
          </div>
        </div>

        <div className="installation-text">
          <h1 className="title title-red">
            Your org is not eligible for upgrade {"("}Current version: {upgradePackageInfo?.package_installed}{")"}
          </h1>
        </div>

        {countdown !== null && (
          <div className="workspace-redirect">
            Redirecting to workspace in{" "}
            <span className="timer">{countdown} seconds</span>
          </div>
        )}

        <div className="workspace-redirect" style={{marginTop:'33px'}}>
          Contact support for assistance:{" "}
          <a href="mailto:care@screen-magic.com">care@screen-magic.com</a>
        </div>
      </main>
    </div>
  );
};

export default OrgUpgradeNotEligible;
